module.exports = __webpack_public_path__ + "img/hp-v1.71067aa7.svg";